import React from 'react';
import PropTypes from 'prop-types';
import QuoteView from '../quoteView';
import QuoteProductComponent from './QuoteProductComponent';
import { ProductConfiguration } from '../../../products/productConfiguration';
import { FormDropdown as Dropdown } from '@ami/react/core';
import {
  priceModeOptions,
  getMsrpColumnClassNames,
  getDNetColumnClassNames,
} from '../../../quotes/quotePriceMode';
import { PricingAndLeadTimesBanner } from '../../PricingAndLeadTimesBanner';
import { QuoteProductConfiguration } from '../../../quotes/quoteProductConfiguration';
import { Spinner } from '@ami/react/core';

export default class ProductsComponent extends React.Component {
  static propTypes = {
    quote: PropTypes.instanceOf(QuoteView).isRequired,
    selectedPriceMode: PropTypes.string.isRequired,
    updatePriceMode: PropTypes.func.isRequired,
    refreshQuote: PropTypes.func.isRequired
  };

  state = {
    productConfiguration: null,
    quoteProductConfiguration: null
  };

  async componentDidMount() {
    const { quote } = this.props;

    this.setState({ productConfiguration: await ProductConfiguration.get() });
    this.setState({ quoteProductConfiguration: await QuoteProductConfiguration.getProductConfiguration(quote.step1Data, quote.attachmentPoints) });
  }

  refreshQuote = () => {
    this.props.refreshQuote();
  }

  updateLeadTimeOverride = (leadTime, index) => {
    let product = this.props.quote.products[index];
    if (product) {
      product.leadTime = leadTime;
      this.forceUpdate();
    }
  };

  render() {
    if (!this.state.productConfiguration || !this.state.quoteProductConfiguration)
      return (
        <div className="d-flex justify-content-center">
          <Spinner show={true} size="fa-5x" />
        </div>
      );

    const { quote, selectedPriceMode, updatePriceMode, refreshQuote } = this.props;
    const msrpClassNames = getMsrpColumnClassNames(selectedPriceMode);
    const dNetClassNames = getDNetColumnClassNames(selectedPriceMode);

    return (
      <div className="card mb-3 box-shadow">
        <div className="card-body">
          <div className="row">
            <div className="offset-md-3 col-md-6">
              <h6 className="card-title text-center">Products</h6>
            </div>
            <div className="col-md-3">
              <Dropdown
                placeholder="Pick a price mode"
                label=""
                items={Object.keys(priceModeOptions).map((x) => ({
                  id: x,
                  label: priceModeOptions[x],
                }))}
                selectedId={selectedPriceMode}
                onChange={(selectedValue) => updatePriceMode(selectedValue)}
              />
            </div>
          </div>
          {quote.products.length === 0 && (
            <div className="text-center p-2">No Products in Quote</div>
          )}
          {quote.maskPricingAndLeadTimes && <PricingAndLeadTimesBanner />}
          {quote.products.length > 0 &&
            <table className="table quote-view-table quote-view-products-table table-mobile">
              <thead>
                <tr>
                  <th width="12%"></th>
                  <th width="32%" className="text-start">
                    Details
                  </th>
                  <th width="12%" className="text-center">
                    Lead Time
                  </th>
                  <th width="44%">
                    <div className="row">
                      <div className="col-6"></div>
                      <div className={msrpClassNames}>MSRP</div>
                      <div className={dNetClassNames}>D. NET</div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {quote.products.map((product, i) => {
                  return (
                    <QuoteProductComponent
                      key={i}
                      index={i}
                      product={product}
                      productConfiguration={this.state.productConfiguration}
                      quoteProductConfiguration={this.state.quoteProductConfiguration}
                      selectedPriceMode={selectedPriceMode}
                      isoCurrencySymbol={quote.isoCurrencySymbol}
                      quote={quote}
                      onLeadTimeOverrideUpdated={this.updateLeadTimeOverride}
                      refreshQuote={refreshQuote}
                    />
                  )
                })}
              </tbody>
            </table>
          }
        </div>
      </div>
    );
  }
}
